<!--工伤认定单-->
<template>
  <div
    class="hbn-container"
    id="userInfo"
  >
    <div class="search-form">
      <!-- 查询区域 -->
      <el-form
        :inline="true"
        ref="form"
        :model="PageQuery.queryModel"
        size="small"
        label-width="70px"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="受伤时间">
              <el-date-picker
                v-model="PageQuery.queryModel.injuryTime"
                style="width:18rem"
                type="daterange"
                range-separator=" - "
                start-placeholder="开始"
                end-placeholder="结束"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="省-市-县">
              <el-select
                style="width:10rem"
                v-model="PageQuery.queryModel.ProvinceCode"
                filterable
                placeholder="请选择省"
                @change="ProvinceChange"
              >
                <el-option
                  v-for="item in ProvinceList"
                  :key="item.code"
                  :label="item.areaName"
                  :value="item.code"
                >
                </el-option>
              </el-select>

              <el-select
                style="width:10rem"
                v-model="PageQuery.queryModel.CityCode"
                filterable
                placeholder="请选择市"
                @change="CityChange"
              >
                <el-option
                  v-for="item in CityList"
                  :key="item.code"
                  :label="item.areaName"
                  :value="item.code"
                >
                </el-option>
              </el-select>

              <el-select
                style="width:10rem"
                v-model="PageQuery.queryModel.RegionCode"
                filterable
                placeholder="请选择区"
              >
                <el-option
                  v-for="item in RegionList"
                  :key="item.code"
                  :label="item.areaName"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div class="operation-btn">
                <el-button @click="seach">查找</el-button>
                <el-button @click="reset">重置</el-button>
                <span @click="onStowChange">{{isStow?'收起':'展开'}}</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          v-show="isStow"
        >
          <el-col :span="8">
            <el-form-item label="姓名">
              <el-input
                v-model="PageQuery.queryModel.InjuryUserName"
                placeholder="姓名"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工伤单位">
              <el-select
                v-model="PageQuery.queryModel.injuryUnitRange"
                placeholder="工伤单位"
                multiple
                filterable
                collapse-tags
                collapse-tags-tooltip
                remote
                :remote-method="remoteMethodUnit"
              >
                <el-option
                  v-for="item in optionUnits"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="伤害类型">
              <el-select
                v-model="PageQuery.queryModel.injuryPartRange"
                placeholder="伤害类型"
                multiple
                filterable
                collapse-tags
                collapse-tags-tooltip
                remote
                :remote-method="remoteMethodInjuryPart"
              >
                <el-option
                  v-for="item in injuryPartOpt"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          v-show="isStow"
        >
          <el-col :span="8">
            <el-form-item label="受伤部位">
              <el-select
                v-model="PageQuery.queryModel.injurySiteRange"
                placeholder="受伤部位"
                multiple
                filterable
                collapse-tags
                collapse-tags-tooltip
                remote
                :remote-method="remoteMethodInjurySite"
              >
                <el-option
                  v-for="item in injurySiteOpt"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职业病">
              <el-select
                v-model="PageQuery.queryModel.occupationDiseaseRange"
                placeholder="职业病"
                multiple
                filterable
                collapse-tags
                collapse-tags-tooltip
                remote
                :remote-method="remoteMethodoccupationDisease"
              >
                <el-option
                  v-for="item in occupationDiseaseOpt"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属行业">
              <el-select
                v-model="PageQuery.queryModel.injuryTypeRange"
                placeholder="所属行业"
                multiple
                filterable
                collapse-tags
                collapse-tags-tooltip
                remote
                :remote-method="remoteMethodinjuryType"
              >
                <el-option
                  v-for="item in injuryTypeOpt"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          v-show="isStow"
        >
          <el-col :span="8">
            <el-form-item label="岗位">
              <el-input
                v-model="PageQuery.queryModel.post"
                placeholder="岗位"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="入职时间"
              prop="entryDate"
            >
              <el-date-picker
                v-model="PageQuery.queryModel.entryDate"
                type="daterange"
                range-separator=" - "
                start-placeholder="开始"
                end-placeholder="结束"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          v-show="isStow"
        >
          <el-col :span="8">
            <el-form-item label="年龄范围">
              <div class="ageRange">
                <el-input-number
                  v-model="PageQuery.queryModel.ageRangeBegin"
                  class="w-50 m-2"
                  :suffix-icon="Calendar"
                  style="width:40%;"
                  :min="0"
                  :controls="false"
                />
                <span> &nbsp;-&nbsp; </span>
                <el-input-number
                  v-model="PageQuery.queryModel.ageRangeEnd"
                  class="w-50 m-2"
                  :prefix-icon="Search"
                  style="width:40%;"
                  :min="0"
                  :controls="false"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="性别"
              prop="sex"
            >
              <el-select
                v-model="PageQuery.queryModel.sex"
                placeholder="性别"
              >
                <el-option
                  v-for="item in SexList"
                  :key="item.val"
                  :label="item.name"
                  :value="item.val"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          @click="addData"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
        <el-button
          type="primary"
          class="custom-button"
          @click="importExcel"
        >
          <i class="el-icon-upload custom-icon"></i>
          <span>导入</span>
        </el-button>
        <el-button
          type="primary"
          class="custom-button"
          @click="exportExcel"
        >
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
        <!--<el-button type="primary" class="custom-button" @click="OpStatus(1)">
            <span>审核</span>
        </el-button>
        <el-button type="primary" class="custom-button" @click="OpStatus(2)">
            <span>终止</span>
        </el-button> -->
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            v-loading="loading"
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="selectAllChangeEvent"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template
              v-for="(item, key) in InjuryAffirmBillList"
              :key="key"
            >
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
            </template>

            <vxe-table-column
              width="150"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Modify')"
                  v-show="DataList[rowIndex].status == 0"
                >编辑</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Detail')"
                >查看</el-button>
                <el-popconfirm
                  title="是否要删除?"
                  @confirm="handleClick(rowIndex, 'Delete')"
                >
                  <template #reference>
                    <el-button
                      size="small"
                      type="text"
                      v-show="DataList[rowIndex].status == 0"
                    >删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.PageIndex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
            <template #left>
              <span class="page-left">
                <span>已选中 {{ checkendSum }}</span>
                <span
                  class="clear"
                  @click.prevent="clearCheckboxRow()"
                >清空</span>
              </span>
            </template>
          </vxe-pager>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <InjuryAffirmBillEdit
      ref="InjuryAffirmBillEdit"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></InjuryAffirmBillEdit>
    <excel
      controlName="injuryAffirmBill"
      fileName="工伤认定单导入模板.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeUpDialog"
      @error="error"
      @success="success"
      type="铁安通"
    ></excel>
  </div>
</template>

<script>
import { InjuryAffirmBillList } from "@/assets/apiData/InjuryAffirmBillList";
import {
  GetDataInjuryAffirmBillListByPageQuery,
  DeleteInjuryAffirmBill,
  ExportInjuryAffirmBill,
} from "@api/ApiInjuryAffirmBill";
import { ProvinceList } from "@/assets/apiData/Province";
import InjuryAffirmBillEdit from "@comp/Basic/InjuryAffirmBillEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
// import XEUtils from "xe-utils";
import { dateFormat } from "@/util/utils.js";
import { GetDataInjuryUnitList } from "@api/ApiInjuryUnit";
import { GetDatainjuryPartList } from "@api/ApiInjuryPart";
import { GetDataInjurySiteList } from "@api/ApiInjurySite";
import { GetDataOccupationDiseaseList } from "@api/ApiOccupationDisease";
import { GetDataInjuryTypeList } from "@api/ApiInjuryType";

export default {
  data() {
    return {
      loading: false,
      PageQuery: {
        queryModel: {
          ProvinceCode: "",
          CityCode: "",
          RegionCode: "",
          InjuryUserName: "",
          InjuryUnitName: "",
          injuryUnitRange: [],
          injuryPartRange: [],
          injurySiteRange: [],
          occupationDiseaseRange: [],
          injuryTypeRange: [],
          post: "",
          entryDate: [],
          entryDateBegin: "",
          entryDateEnd: "",
          injuryTime: [],
          injuryTimeBegin: "",
          injuryTimeEnd: "",
          sex: "",
          ageRangeBegin: "",
          ageRangeEnd: "",
          type: "铁安通",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      show: false,
      InjuryAffirmBillList: [],
      DataList: [],
      OpStatusList: [
        { id: 0, txt: "未审批" },
        { id: 1, txt: "已审核" },
        { id: 2, txt: "已终止" },
      ],
      ProvinceList: [],
      CityList: [],
      RegionList: [],
      Units: [], //工伤单位
      optionUnits: [],
      SexList: [
        { name: "男", val: 0 },
        { name: "女", val: 1 },
      ],
      injuryPartList: [],
      injuryPartOpt: [],
      injurySiteList: [],
      injurySiteOpt: [],
      occupationDiseaseList: [],
      occupationDiseaseOpt: [],
      injuryTypeList: [],
      injuryTypeOpt: [],
      isStow: false, // 是否展开  true:展开  false:收起
    };
  },
  components: {
    InjuryAffirmBillEdit,
    excel,
  },
  computed: {
    checkendSum() {
      if (!this.multipleSelection) return 0;
      return this.multipleSelection.length;
    },
  },
  methods: {
    // 控制展开/收起
    onStowChange() {
      this.isStow = this.isStow ? false : true;
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          if(cellValue) {
            cellValue = dateFormat("YYYY-mm-dd HH:MM:SS", new Date(cellValue));
          }
          break;
        case "date":
          if(cellValue) {
            cellValue = dateFormat("YYYY-mm-dd", new Date(cellValue));
          }
          break;
        case "checkbox":
          cellValue = cellValue == "1" ? "是" : "否";
          break;
        case "status":
          cellValue = cellValue == "1" ? "启用" : "停用";
          break;
      }
      return cellValue;
    },
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
      this.PageQuery.PageIndex = 1;
      this.PageQuery.Conditions = [];
      this.GetData();
    },
    importExcel() {
      this.UpLoaddialogVisible = true;
    },
    exportExcel() {
      if (this.multipleSelection.length == 0) {
        try {
          let _this = this;
          if (_this.PageQuery.queryModel.entryDate.length == 2) {
            _this.PageQuery.queryModel.entryDateBegin = dateFormat(
              "YYYY-mm-dd",
              new Date(_this.PageQuery.queryModel.entryDate[0])
            );
            _this.PageQuery.queryModel.entryDateEnd = dateFormat(
              "YYYY-mm-dd",
              new Date(_this.PageQuery.queryModel.entryDate[1])
            );
          } else {
            _this.PageQuery.queryModel.entryDateBegin = "";
            _this.PageQuery.queryModel.entryDateEnd = "";
          }
          if (_this.PageQuery.queryModel.injuryTime.length == 2) {
            _this.PageQuery.queryModel.injuryTimeBegin = dateFormat(
              "YYYY-mm-dd",
              new Date(_this.PageQuery.queryModel.injuryTime[0])
            );
            _this.PageQuery.queryModel.injuryTimeEnd = dateFormat(
              "YYYY-mm-dd",
              new Date(_this.PageQuery.queryModel.injuryTime[1])
            );
          } else {
            _this.PageQuery.queryModel.injuryTimeBegin = "";
            _this.PageQuery.queryModel.injuryTimeEnd = "";
          }
          ExportInjuryAffirmBill(_this.PageQuery.queryModel).then((result) => {
            if (result.response.status == 500) {
              this.$message.warning("查询到的数据为空");
            }
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        this.export2Excel();
      }
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(v.InjuryAffirmBillList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.InjuryAffirmBillList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名

        const list =
          v.multipleSelection.length == 0 ? v.DataList : v.multipleSelection;

        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `工伤认定单`);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleClick(index, type) {
      console.log(index, type);

      this.InjuryAffirmBillEdit(index, type);
    },
    InjuryAffirmBillEdit(index, type) {
      var _this = this;
      if (type == "Delete") {
        DeleteInjuryAffirmBill(_this.DataList[index].id).then(function (data) {
          if (data) {
            _this.$message.success("删除成功");
            _this.PageQuery.pageindex = 1;
            _this.GetData();
          }
        });
      } else {
        _this.dialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        _this.$refs.InjuryAffirmBillEdit.loadDataById(id, type);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //选中事件
    handleSelectionChange({ records }) {
      this.multipleSelection = records;
    },
    selectAllChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    //清空
    clearCheckboxRow() {
      this.$refs.multipleTable.clearCheckboxRow();
      this.multipleSelection = [];
    },
    addData() {
      this.InjuryAffirmBillEdit(-1, "Add");
    },
    seach() {
      this.PageQuery.PageIndex = 1;
      this.GetData();
    },
    reset(){
      this.PageQuery.queryModel = {
        ProvinceCode: "",
        CityCode: "",
        RegionCode: "",
        InjuryUserName: "",
        InjuryUnitName: "",
        injuryUnitRange: [],
        injuryPartRange: [],
        injurySiteRange: [],
        occupationDiseaseRange: [],
        injuryTypeRange: [],
        post: "",
        entryDate: [],
        entryDateBegin: "",
        entryDateEnd: "",
        injuryTime: [],
        injuryTimeBegin: "",
        injuryTimeEnd: "",
        sex: "",
        ageRangeBegin: "",
        ageRangeEnd: "",
        type: "铁安通",
      };
    },
    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.PageIndex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.PageIndex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      // this.GetData();
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    GetData() {
      const _this = this;
      this.multipleSelection = [];
      _this.SearchDataInfo();
      try {
        if (_this.PageQuery.queryModel.entryDate.length == 2) {
          _this.PageQuery.queryModel.entryDateBegin = dateFormat(
            "YYYY-mm-dd",
            new Date(_this.PageQuery.queryModel.entryDate[0])
          );
          _this.PageQuery.queryModel.entryDateEnd = dateFormat(
            "YYYY-mm-dd",
            new Date(_this.PageQuery.queryModel.entryDate[1])
          );
        } else {
          _this.PageQuery.queryModel.entryDateBegin = "";
          _this.PageQuery.queryModel.entryDateEnd = "";
        }
        if (_this.PageQuery.queryModel.injuryTime.length == 2) {
          _this.PageQuery.queryModel.injuryTimeBegin = dateFormat(
            "YYYY-mm-dd",
            new Date(_this.PageQuery.queryModel.injuryTime[0])
          );
          _this.PageQuery.queryModel.injuryTimeEnd = dateFormat(
            "YYYY-mm-dd",
            new Date(_this.PageQuery.queryModel.injuryTime[1])
          );
        } else {
          _this.PageQuery.queryModel.injuryTimeBegin = "";
          _this.PageQuery.queryModel.injuryTimeEnd = "";
        }
        this.loading = true;
        GetDataInjuryAffirmBillListByPageQuery(_this.PageQuery).then(function (
          data
        ) {
          _this.loading = false;
          data.entities.forEach((e) => {
            // if (e.status == null)
            //   e.status = v.OpStatusList.find((x) => x.id == 0).txt;
            // else e.status = v.OpStatusList.find((x) => x.id == e.status).txt;
            e.isDeath = e.isDeath ? "是" : "否";
            e.sex = e.sex == 0 ? "男" : e.sex == 1 ? "女" : "未知";
            if (e.injuryTime)
              e.injuryTime = _this.dateFormat(
                "YYYY-mm-dd",
                new Date(e.injuryTime)
              );
            // if(e.applyTime)e.applyTime=_this.dateFormat('YYYY-mm-dd',new Date(e.applyTime))
            // if(e.acceptanceTime)e.acceptanceTime=_this.dateFormat('YYYY-mm-dd',new Date(e.acceptanceTime))
            // if(e.reviewSignatureTime)e.reviewSignatureTime=_this.dateFormat('YYYY-mm-dd',new Date(e.reviewSignatureTime))
          });
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        _this.loading = false;
        console.log(e);
      }
    },
    SearchDataInfo() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.PageIndex = 1;
      this.GetData();
    },
    ProvinceChange() {
      const _this = this;
      _this.PageQuery.queryModel.CityCode = "";
      _this.ProvinceList.map((x) => {
        if (x.code == _this.PageQuery.queryModel.ProvinceCode) {
          _this.CityList = JSON.parse(JSON.stringify(x.children));
          _this.CityList.unshift({
            areaName: "-请选择-",
            code: "",
          });
        }
      });
    },
    CityChange() {
      const _this = this;
      _this.PageQuery.queryModel.RegionCode = "";
      _this.ProvinceList.map((x) => {
        if (x.code == _this.PageQuery.queryModel.ProvinceCode) {
          _this.RegionList = JSON.parse(
            JSON.stringify(
              x.children.filter(
                (o) =>
                  o.level == 4 &&
                  o.parentCode == _this.PageQuery.queryModel.CityCode
              )
            )
          );
          _this.RegionList.unshift({
            areaName: "-请选择-",
            code: "",
          });
        }
      });
    },
    remoteMethodUnit(query) {
      if (query !== "") {
        this.optionUnits = this.Units.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.optionUnits = this.Units;
      }
    },
    remoteMethodInjuryPart(query) {
      if (query !== "") {
        this.injuryPartOpt = this.injuryPartList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injuryPartOpt = this.injuryPartList;
      }
    },
    remoteMethodInjurySite(query) {
      if (query !== "") {
        this.injurySiteOpt = this.injurySiteList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injurySiteOpt = this.injurySiteList;
      }
    },
    remoteMethodoccupationDisease(query) {
      if (query !== "") {
        this.occupationDiseaseOpt = this.occupationDiseaseList.filter(
          (item) => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          }
        );
      } else {
        this.occupationDiseaseOpt = this.occupationDiseaseList;
      }
    },
    remoteMethodinjuryType(query) {
      if (query !== "") {
        this.injuryTypeOpt = this.injuryTypeList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injuryTypeOpt = this.injuryTypeList;
      }
    },
  },
  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
    this.InjuryAffirmBillList = InjuryAffirmBillList;
    this.GetData();
    let _this = this;
    let PageQuery = {
      queryModel: {
        name: "",
        type: "铁安通",
      },
      pageindex: 1,
      pageSize: 100000,
    };
    GetDataInjuryUnitList(PageQuery).then(function (data) {
      _this.Units = data.entities;
    });
    GetDatainjuryPartList(PageQuery).then(function (data) {
      _this.injuryPartList = data.entities;
    });
    GetDataInjurySiteList(PageQuery).then(function (data) {
      _this.injurySiteList = data.entities;
    });
    GetDataOccupationDiseaseList(PageQuery).then(function (data) {
      _this.occupationDiseaseList = data.entities;
    });
    GetDataInjuryTypeList(PageQuery).then(function (data) {
      _this.injuryTypeList = data.entities;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.operation-btn {
  display: flex;
  align-items: center;
  .el-button {
    width: 75px;
    height: 32px;
    background: #f7971e;
    border: 0;
    color: #ffffff;
    border-radius: 2px;
  }
  span {
    cursor: pointer;
    color: #0747a6;
    margin-left: 30px;
  }
}
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}

.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}

.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}

/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #ffffff;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #ffffff;
}

.page-left {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.operation {
  display: flex;
}

.pagination {
  margin: 0;
  width: 100%;
  /* position: absolute;
        bottom: 0; */
  background-color: #fff;
  z-index: 7;
  padding: 5px 0;
}
</style><style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
</style>
<style scoped>
.search-form /deep/ .el-form-item__content {
  max-width: 100%;
}
.search-form /deep/ .el-date-editor.el-input {
  width: 100px;
}
.search-form /deep/ .el-date-editor.el-input__inner {
  /* max-width: 150px; */
}
</style>
